// Normalise a word for matching: Cyrillic → Latin, lower case, accents removed
// (ő → o, č → c, đ → dj). Chrome's Serbian speech recognition often answers in
// Cyrillic; typed input often has no accents. Both match the same entries.

const CYRILLIC: Record<string, string> = {
  а: 'a',
  б: 'b',
  в: 'v',
  г: 'g',
  д: 'd',
  ђ: 'dj',
  е: 'e',
  ж: 'z',
  з: 'z',
  и: 'i',
  ј: 'j',
  к: 'k',
  л: 'l',
  љ: 'lj',
  м: 'm',
  н: 'n',
  њ: 'nj',
  о: 'o',
  п: 'p',
  р: 'r',
  с: 's',
  т: 't',
  ћ: 'c',
  у: 'u',
  ф: 'f',
  х: 'h',
  ц: 'c',
  ч: 'c',
  џ: 'dz',
  ш: 's',
};

export function fold(s: string): string {
  return s
    .toLowerCase()
    .replace(/[Ѐ-ӿ]/g, (ch) => CYRILLIC[ch] ?? ch)
    .replace(/đ/g, 'dj')
    .replace(/ø/g, 'o')
    .replace(/æ/g, 'ae')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');
}

/** Cyrillic → Latin, keeping case and accents — for showing the transcript. */
export function toLatin(s: string): string {
  return s.replace(/[Ѐ-ӿ]/g, (ch) => {
    const lower = ch.toLowerCase();
    const latin = LATIN_ACCENTED[lower] ?? CYRILLIC[lower] ?? ch;
    return ch === lower ? latin : latin.charAt(0).toUpperCase() + latin.slice(1);
  });
}

const LATIN_ACCENTED: Record<string, string> = { ђ: 'đ', ж: 'ž', ћ: 'ć', ч: 'č', џ: 'dž', ш: 'š' };
